const headers = {
  name: "Chart of Accounts",
  navigate: {
    tabs: [
      {
        name: "Chart of Accounts",
        path: "/app/accounting/chart-of-accounts",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
